import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class MPGRepository<MPGModel> extends RepositoryBase<MPGModel> {
    public constructor() {
        super('MPG');
    }
}
